import React, { Component } from "react";
import axios from "axios";
import { Buffer } from "buffer";

import { MDBContainer, MDBBtn, MDBInput, MDBSpinner } from "mdb-react-ui-kit";

import Reports from "./sub-components/reports";

import "../stylesheets/reports.css";

class GenerateReports extends Component {
   state = {
      displayReports: false
   }

   months = ["-1", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
   reports = [];
   type = "";
   monthYear = "";

   validate = async () => {
      const monthYear = document.querySelector(".month-year-input").value;
      const monthYearError = document.querySelector(".month-year-span");

      this.type = document.querySelector(".type-select");
      const typeError = document.querySelector(".type-span").style;

      monthYearError.style.display = "none";
      typeError.display = "none";

      let month, year, monthYearSuccess = false;
      if (/^\d{2}-\d{4}$/.test(monthYear)) {
         month = parseInt(/\d{2}/.exec(monthYear));
         year = parseInt(/\d{4}/.exec(monthYear));
         const currentYear = new Date().getFullYear();
         let monthNotInRange = !(1 <= month && month <= 12), yearNotInRange = !(1970 <= year && year <= currentYear);

         if (monthNotInRange && yearNotInRange) {
            monthYearError.style.display = "inherit";
            monthYearError.textContent = "Month and Year are not in range";
         } else if (monthNotInRange) {
            monthYearError.style.display = "inherit";
            monthYearError.textContent = "Month must be in range of [1, 12]";
         } else if (yearNotInRange) {
            monthYearError.style.display = "inherit";
            monthYearError.textContent = "Year must be in range [1970, " + currentYear + "]";
         } else {
            monthYearError.style.display = "none";
            monthYearSuccess = true;
         }
      } else {
         monthYearError.style.display = "inherit";
         if (monthYear === "") {
            monthYearError.textContent = "Please input Month and Year";
         } else {
            monthYearError.textContent = "Please input Month and Year in MM-YYYY format";
         }
      }

      let typeSuccess = false;
      if (this.type.value === "select") {
         typeError.display = "inherit";
      } else {
         typeError.display = "none";
         typeSuccess = true;
      }

      this.monthYear = this.months[month] + year;
      if (monthYearSuccess && typeSuccess) {
         this.showReports(this.monthYear, this.type.value);
      }
   }

   // extracting only required fields from response of free service list
   fsrRequiredKeys = ["unit-sl-no", "vehicle-no", "model-no", "customer-name", "address", "date-of-inst", "month_diff"];
   freeServiceReports = (data) => {
      let i, j, dataLength = data.length;
      let rkLength = this.fsrRequiredKeys.length;

      for (j = 0; j < dataLength; j++) {
         this.reports[j] = {};
      }

      let dataValue;
      for (i = 0; i < dataLength; i++) {
         for (j = 0; j < rkLength; j++) {
            dataValue = data[i][this.fsrRequiredKeys[j]];
            if ((this.fsrRequiredKeys[j] in data[i]) && dataValue !== "" && dataValue !== null && dataValue !== undefined) {
               this.reports[i][this.fsrRequiredKeys[j]] = dataValue;
            } else {
               this.reports[i][this.fsrRequiredKeys[j]] = "-";
            }
         }
      }
   }

   // extracting only required fields from response of free service list
   warrantyReports = (data) => {
      let i, dataLength = data.length;

      for (i = 0; i < dataLength; i++) {
         this.reports.push({
            "job-card-no": data[i]["job-card-no"],
            "service-req-no": data[i]["service-req-no"],
            "part-no": data[i]["part-no"],
            "part-name": data[i]["part-name"],
            "qty": data[i]["qty"],
            "qty-unit": data[i]["qty-unit"],
         });
      }
   }

   showReports = async (monthYearParameter, typeParameter) => {
      const spinnerStyle = document.querySelector(".spinner").style;
      spinnerStyle.display = "flex";

      const grButton = document.querySelector(".gr-button");
      grButton.setAttribute("disabled", true);

      const url = `https://p4d-sutlej.kreativit.in:443/kitmyclients-apis/v1/business_report_builder/RSCS/transactionals?name=${typeParameter}&current_month=${monthYearParameter}`;
      await axios(url, {
         headers: {
            Authorization: "Basic " + Buffer.from("RSCS_admin:admin@scsr").toString("base64"),
            "Auth-Token": "5905d234-34f7-53ce-b192-a886192134ca",
            "Content-Type": "application/json",
            "Accept": "application/json"
         }
      })
         .then(res => res.data)
         .then(res => {
            this.reports = [];
            const data = res.data;
            if (data.length !== 0) {
               if (typeParameter === "vehicle_job_card") this.freeServiceReports(data);
               else if (typeParameter === "warranty_card") this.warrantyReports(data);
            }

            this.setState({ displayReports: true });
         })
         .catch((err) => console.log(err));

      spinnerStyle.display = "none";
      grButton.removeAttribute("disabled");
   };

   render() {
      return (
         <MDBContainer className="d-flex flex-column justify-content-center align-items-center mt-5">
            {/* ============= Spinner (or) Loader ============= */}
            <MDBContainer className="spinner" style={{ display: "none" }}>
               <MDBSpinner className="me-2" color="dark" style={{ width: "5rem", height: "5rem" }}></MDBSpinner>
            </MDBContainer>

            <h2><u>Generate Reports</u></h2>
            <div className="mt-2 d-flex align-items-center">
               <strong style={{ "textAlign": "center" }}>Month & Year <br /> (Format: MM-YYYY)</strong>
               <strong>:</strong>
               <pre>  </pre>
               <MDBInput type="text" className="month-year-input" label="MM-YYYY" />
            </div>
            <span className="month-year-span"></span>

            <div className="mt-3 d-flex align-items-center">
               <strong>Type:</strong>
               <pre>  </pre>
               <select className="type-select">
                  <option value="select">-- Select Type --</option>
                  <option value="vehicle_job_card">Free Service List</option>
                  <option value="warranty_card">Warranty Parts Reimbursement</option>
               </select>
            </div>
            <span className="type-span">Please Select a type before proceeding</span>

            <MDBBtn className="gr-button my-3" onClick={this.validate}>Generate</MDBBtn>

            {this.state.displayReports && <Reports reports={this.reports} monthYear={this.monthYear} type={this.type.options[this.type.selectedIndex].text} />}
         </MDBContainer>
      );
   }
}

export default GenerateReports;
